import base from '../dr-base'
import drBaseActions from '../dr-base-actions'
import drTextField from './dr-text-field.vue'

const schema = {
  $Type: 'dr-text-field',
  name: 'Text box',
  group: 'Input widgets',
  icon: 'pen-alt',
  ...base,
  properties: {
    ...base.properties,
    Disabled: {
      name: 'vuetifyWidgets.dr-text-field.disabled',
      type: 'string',
      default: ''
    },
    Caption: {
      name: 'vuetifyWidgets.dr-text-field.caption',
      type: 'string'
    },
    Value: {
      name: 'vuetifyWidgets.dr-text-field.value',
      type: 'string',
      component: 'dr-value-editor'
    },
    Readonly: {
      name: 'vuetifyWidgets.dr-text-field.readonly',
      type: 'string'
    },
    Required: {
      name: 'vuetifyWidgets.dr-text-field.required',
      type: 'boolean'
    },
    TabIndex: {
      name: 'vuetifyWidgets.dr-text-field.tabIndex',
      type: 'number'
    },
    Mask: {
      name: 'vuetifyWidgets.dr-text-field.mask',
      type: 'string'
    },
    Style: {
      name: 'vuetifyWidgets.dr-text-field.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    IsClearable: {
      name: 'Clearable',
      type: 'boolean',
      default: false
    },
    Type: {
      name: 'vuetifyWidgets.dr-text-field.type',
      type: 'string',
      default: 'text',
      enum: [{
        value: 'text',
        text: 'vuetifyWidgets.dr-text-field.text'
      }, {
        value: 'password',
        text: 'vuetifyWidgets.dr-text-field.password'
      }, {
        value: 'number',
        text: 'vuetifyWidgets.dr-text-field.number'
      }]
    },
    PositionIcon: {
      name: 'vuetifyWidgets.dr-text-field.positionIcon',
      type: 'string',
      default: '',
      enum: [{
        value: '',
        text: 'None'
      }, {
        value: 'prepend-icon',
        text: 'Prepend'
      }, {
        value: 'prepend-inner-icon',
        text: 'Prepend inner'
      }, {
        value: 'append-icon',
        text: 'Append'
      }, {
        value: 'append-outer-icon',
        text: 'Append outer'
      }]
    },
    IconName: {
      name: 'vuetifyWidgets.dr-text-field.iconName',
      type: 'string',
      default: '',
      component: 'dr-icon-picker'
    },
    IconActionOnclick: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-text-field.iconActionOnclick'
    },
    KeyActionOnclick: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-text-field.keyActionOnclick'
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-text-field.generationOnChange'
    }
  }
}

export default {
  schema,
  component: drTextField,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
